  <div style="height: 12vh;">
    <div>
      <label i18n="@@wordTemplateTitle" class="textColour" [ngStyle]="{'border-color':backgroundColorButton}">
        {{titleText}}
      </label>
      <span class="example-spacer"></span>
    </div>
  </div>
<mat-dialog-content>

  <mat-form-field appearance="outline" class="w-full" style="margin-top:1rem;">
    <mat-label>Columns</mat-label>
    <mat-select [(value)]="selectedFields" multiple>
      <mat-option *ngFor="let c of data.toggleableCols" [value]="c.field">
        {{ c.headerName }}
      </mat-option>
    </mat-select>
  </mat-form-field>

  <!-- Action row for Select All / Clear -->
  <div class="flex gap-2 mt-2">
    <button 
      class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      style="padding:4px 12px; font-size:12px; min-width:70px; height:32px;"
      (click)="selectAll()">
      Select all
    </button>
    <button 
      class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
      [style.background-color]="backgroundColorButton"
      style="padding:4px 12px; font-size:12px; min-width:70px; height:32px;"
      (click)="clearAll()">
      Clear
    </button>
  </div>

</mat-dialog-content>

<mat-dialog-actions align="end">
 <button 
    class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    [style.background-color]="backgroundColorButton"
    style="padding:4px 14px; font-size:13px; min-width:80px; height:34px;"
    (click)="dialogRef.close()">
    Cancel
  </button>
  <button 
    class="download-btn btn btn-rounded-button z-depth-1 waves-effect waves-light text-capitalize"
    [style.background-color]="backgroundColorButton"
    style="padding:4px 14px; font-size:13px; min-width:80px; height:34px;"
    (click)="save()">
    Apply
  </button>
</mat-dialog-actions>
